$('.filter-list__link').on('click', function(e){
	e.preventDefault();
	$('.filter-list__link').not($(this)).removeClass('active');
	$('.filter-list__link').not($(this)).next().removeClass('show');

	if (!$(this).hasClass('active')) {
		$(this).addClass('active');
		$(this).next().addClass('show');
	}else{
		$(this).removeClass('active');
		$(this).next().removeClass('show');
	}
})

$('.filter__btn').on('click', function(){
	$('.filter-dropdown__item').find('input').prop("checked", false);
})